import { useState } from "react";
import { v4 } from "uuid";
import Button from "../components/Button";
import { randomGesture } from "../oz/constants/ozLivenessConstant";
import { handleLivenessResult } from "../services/ozservices";
import { OzLivenessResult } from "../types/type";

const intitalResult = {
  confidence_spoofing: "",
  message: "",
};

const Home = () => {
  const transactionId = v4();
  const [result, setResult] = useState(intitalResult);

  const handleStartLiveness = () => {
    try {
      setResult(intitalResult);
      window.OzLiveness.open({
        lang: "en",
        action: [randomGesture()],
        meta: {
          user_id: "adbl",
          transaction_id: transactionId,
        },

        on_error: (result: OzLivenessResult) =>
          console.error("on_error", result),
        on_submit: (result: OzLivenessResult) =>
          console.log("on_submit", result),
        on_result: (result: OzLivenessResult) =>
          console.log("on_result", result),
        on_complete: async (result: OzLivenessResult) => {
          const response = await handleLivenessResult({ transactionId });

          const confidence_spoofing =
            response.items[0].analyses[0].results_media[0].results_data
              .confidence_spoofing || "";

          const message =
            response.items[0].analyses[0].resolution_status === "SUCCESS"
              ? "Everything Fine"
              : "Attack Detected";

          setResult({
            confidence_spoofing: `${Number(confidence_spoofing) * 100}`,
            message,
          });
        },
        on_close: (result: OzLivenessResult) => console.log("on_close", result),
        on_capture_complete: (result: OzLivenessResult) =>
          console.log("on_capture_complete", result),
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <main className="flex justify-center items-center px-8 py-4 ">
      <div className="container p-4">
        <div className="flex flex-col gap-8 justify-center items-center">
          <h1 className="text-5xl">Liveness Demo</h1>

          <div>
            <Button onClick={handleStartLiveness}>Start Liveness</Button>
          </div>
        </div>
        {(result.confidence_spoofing || result.message) && (
          <div className="flex flex-col gap-2 mt-10 ">
            <p className="text-lg font-semibold">Result:</p>
            <p>Spoofing: {result.confidence_spoofing}</p>
            <p>Message: {result.message}</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default Home;
